export default {"src":"/_next/static/media/platformMobileResponsive.dea766c6.svg","height":101,"width":147,"blurWidth":0,"blurHeight":0};